export default "__VITE_ASSET__BHbIhPM7__"